"use strict"

import React, { useEffect, useState } from "react"
import { Modal, Button } from "react-bootstrap"
import { FormattedMessage } from "react-intl"
import PropTypes from "prop-types"

import { API_STATUS } from "../../../shared_components/widgets/utils"
import { sentencify } from "../../../shared_components/utils"
import PageLoadingPanel from "../../../shared_components/widgets/PageLoadingPanel"
import PageErrorPanel from "../../../shared_components/widgets/PageErrorPanel"
import { logToServer } from "../../../ErrorBoundary"
import { getObjectsList } from "../../../Loaders"
import { LocaleFormattedDate, LocaleFormattedUser } from "../../internationalization/LocaleFormatted"
import InventoryItemDetails from "./InventoryItemDetails"

export default function ModalViewInventoryItem({ inventory_item = {}, show, onHide }) {
  const [status_transc, setStatusTransc] = useState(null)
  const [data_transactions, setDataTransactions] = useState([])

  useEffect(() => {
    getTransactions()
  }, [])

  const getTransactions = () => {
    setStatusTransc(API_STATUS.LOADING)

    getObjectsList(
      `/laboratory/inventory/inventory-item-transaction/?item=${inventory_item.id}&ordering=created_on`,
    )
      .then((data) => {
        setDataTransactions(data)
        setStatusTransc(API_STATUS.SUCCESS)
      })
      .catch((error) => {
        logToServer(error)
        console.error(error)
        setStatusTransc(API_STATUS.ERROR)
      })
  }

  return (
    <Modal size={"lg"} show={show} onHide={onHide} backdrop={"static"} keyboard={true}>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className={"fa fa-inbox"} />
          &nbsp;&nbsp;
          <FormattedMessage id={"inventory.item"} /> #{inventory_item.id} - {inventory_item.sku.name} (
          {inventory_item.sku.inventory_type.name})
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ width: "700px" }}>
          {/*---------- Details ----------*/}
          <table className={"table table-sm"}>
            <tbody>
              <InventoryItemDetails inventory_item={inventory_item} />
            </tbody>
          </table>
          {/*---------- /Details ----------*/}

          {/*---------- Transactions ----------*/}
          <h4>Transactions</h4>
          <hr style={{ margin: "10px 0px 10px" }} />
          {status_transc === API_STATUS.LOADING && <PageLoadingPanel />}
          {status_transc === API_STATUS.ERROR && <PageErrorPanel attemptReload={getTransactions} />}
          {status_transc === API_STATUS.SUCCESS && (
            <table className={"table table-bordered table-sm tbl_lanzatable"}>
              <thead>
                <tr>
                  {[
                    ["general.date", "Date"],
                    ["general.type", "Type"],
                    ["stock.quantity", "Quantity"],
                    ["general.remarks", "Remarks"],
                    ["general.user", "User"],
                  ].map((opt, i) => (
                    <th key={`transactionHeader${i}`} className={"text-center"}>
                      <FormattedMessage id={opt[0]} defaultMessage={opt[1]} />
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data_transactions.map((tranc, idx) => (
                  <tr key={idx}>
                    <td>
                      <LocaleFormattedDate date={tranc.created_on} shouldParse={true} />
                    </td>
                    <td>{sentencify(tranc.type)}</td>
                    <td>{tranc.quantity}</td>
                    <td>{tranc.remarks}</td>
                    <td>
                      <LocaleFormattedUser user={tranc.transaction_by} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          {/*---------- /Transactions ----------*/}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant={"outline-primary"} onClick={onHide} style={{ display: "flex", float: "right" }}>
          <FormattedMessage id={"general.closeButton"} />
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

ModalViewInventoryItem.propTypes = {
  inventory_item: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
}
